import ExamRoomAppBar from './ExamRoomAppBar';

export default ExamRoomAppBar;
